
const LoginHeader = () => {
  return (
    <div className="sm:w-1/3 sm:max-md:w-1/5 flex items-center md:h-auto justify-center bg-dark-blue relative 2xs:max-sm:h-28">
      <img src="/Login Vector.svg" alt="loginImg" className="absolute object-contain top-1/2 w-500 -right-[184px] translate-y-50 max-xl:w-200 max-xl:-right-[40px] max-sm:w-44 max-sm:right-0 max-sm:left-0 max-sm:mx-auto max-sm:mt-8" />
    </div>
  );
};
export default LoginHeader;